import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../api/axios";
import { API_ENDPOINTS } from "../api/endpoint";

// Get battle settings (for all users)
export const getBattleSettings = createAsyncThunk(
    'battleSettings/getBattleSettings',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(API_ENDPOINTS.GET_BATTLE_SETTINGS);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Failed to fetch battle settings' });
        }
    }
);

// Admin: Get battle settings with descriptions
export const adminGetBattleSettings = createAsyncThunk(
    'battleSettings/adminGetBattleSettings',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(API_ENDPOINTS.ADMIN_GET_BATTLE_SETTINGS);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Failed to fetch battle settings' });
        }
    }
);

// Admin: Update battle settings
export const adminUpdateBattleSettings = createAsyncThunk(
    'battleSettings/adminUpdateBattleSettings',
    async (settings, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(API_ENDPOINTS.ADMIN_UPDATE_BATTLE_SETTINGS, { settings });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Failed to update battle settings' });
        }
    }
);

const battleSettingsSlice = createSlice({
    name: 'battleSettings',
    initialState: {
        settings: {
            show_default_attacks: '0',
            default_attacks_count: '4',
            battle_timer_seconds: '180',
            healing_time_seconds: '180',
            enemy_strength_percent: '100',
            player_strength_percent: '100'
        },
        adminSettings: {},
        loading: false,
        adminLoading: false,
        updateLoading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        // Get battle settings
        builder.addCase(getBattleSettings.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getBattleSettings.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload?.success && action.payload?.settings) {
                state.settings = action.payload.settings;
            }
        });
        builder.addCase(getBattleSettings.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.error || 'Failed to fetch battle settings';
        });
        
        // Admin: Get battle settings
        builder.addCase(adminGetBattleSettings.pending, (state) => {
            state.adminLoading = true;
            state.error = null;
        });
        builder.addCase(adminGetBattleSettings.fulfilled, (state, action) => {
            state.adminLoading = false;
            if (action.payload?.success && action.payload?.settings) {
                state.adminSettings = action.payload.settings;
            }
        });
        builder.addCase(adminGetBattleSettings.rejected, (state, action) => {
            state.adminLoading = false;
            state.error = action.payload?.error || 'Failed to fetch battle settings';
        });
        
        // Admin: Update battle settings
        builder.addCase(adminUpdateBattleSettings.pending, (state) => {
            state.updateLoading = true;
            state.error = null;
        });
        builder.addCase(adminUpdateBattleSettings.fulfilled, (state, action) => {
            state.updateLoading = false;
        });
        builder.addCase(adminUpdateBattleSettings.rejected, (state, action) => {
            state.updateLoading = false;
            state.error = action.payload?.error || 'Failed to update battle settings';
        });
    }
});

export default battleSettingsSlice.reducer;

